export class ChartDatapoint {
  constructor(
    public name: string,
    public value: number
  ) {}
}
